/*eslint import/no-unresolved: */
import { useRouter } from "next/navigation";
import React from "react";
import HeaderProps from "./types";
import Image from "next/image";

import { Images } from "@/utils/constants/imageRelativePaths";

import styles from "./header.module.scss";

const Header: React.ComponentType<HeaderProps> = ({
  goBack,
  title,
  children,
  rightElem,
  showBackButton = true,
  isRTL,
  theme = "light",
}) => {
  const router = useRouter();

  const handleBackPress = () => {
    if (goBack) {
      goBack();
    } else {
      router.back();
    }
  };

  return (
    <div
      className={`${styles.navContainer} ${
        styles[`nav-${theme === "dark" ? "dark" : "light"}`]
      }`}
    >
      {showBackButton && (
        <div className={styles.backIcon} onClick={handleBackPress}>
          <Image
            className={`${isRTL ? styles.rotate : ""}`}
            src={theme === "dark" ? Images.iconBackWhite : Images.iconBack}
            width={20}
            height={20}
            alt="back"
          />
        </div>
      )}
      <div className={styles.midContainer}>
        {children || null}
        {title && <h1 className={styles.title}>{title}</h1>}
      </div>
      {rightElem || null}
    </div>
  );
};

export default React.memo(Header);
